import React, { useState, useContext } from "react";
import axios from "axios";
import { ThemeContext } from "../../hooks/ThemeContext";

const Register = () => {
    const [formData, setFormData] = useState({
        nickname: "",
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        confirmPassword: "",
    });

    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (formData.password !== formData.confirmPassword) {
            setError("Les mots de passe ne correspondent pas !");
            return;
        }

        try {
            const response = await axios.post("http://ton-backend.com/api/register", {
                nickname: formData.nickname,
                firstname: formData.firstname,
                lastname: formData.lastname,
                email: formData.email,
                password: formData.password,
            });

            console.log(response.data);
            alert("Inscription réussie !");
        } catch (error) {
            console.error(error);
            setError("Erreur lors de l'inscription. Vérifiez vos informations.");
        }
    };

    const { theme } = useContext(ThemeContext);
    const isDark = theme === 'dark';

    return (
        <div className={`min-h-screen flex items-center justify-center ${isDark ? 'bg-[#0f1114]' : 'bg-slate-50'} px-4`}>
            <div className={`${isDark ? 'bg-[#0b0b0c] text-white' : 'bg-white/95 text-gray-800'} p-8 rounded-lg shadow-lg max-w-md w-full`}>
                <h2 className="text-2xl font-bold text-center mb-6">Inscription</h2>

                {/* Message développement */}
                <div className={`mb-6 p-4 rounded-lg border ${isDark ? "bg-amber-500/10 border-amber-500/30 text-amber-400" : "bg-amber-50 border-amber-200 text-amber-700"}`}>
                    <div className="flex items-start gap-3">
                        <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="font-semibold text-sm">Fonctionnalité en développement</p>
                            <p className="text-xs mt-1">L'inscription est actuellement indisponible. Le site est en cours de développement.</p>
                        </div>
                    </div>
                </div>

                {error && <p className="text-red-500 text-center mb-4">{error}</p>}

                <form onSubmit={handleSubmit} className="space-y-4">
                    <input
                        type="text"
                        name="nickname"
                        placeholder="Pseudo"
                        value={formData.nickname}
                        onChange={handleChange}
                        required
                        className={`w-full p-2 border rounded ${isDark ? 'bg-[#0b0b0c] border-white/10 text-white' : 'bg-white/95 border-gray-300 text-gray-800'}`}
                    />
                    <input
                        type="text"
                        name="firstname"
                        placeholder="Prénom"
                        value={formData.firstname}
                        onChange={handleChange}
                        required
                        className={`w-full p-2 border rounded ${isDark ? 'bg-[#0b0b0c] border-white/10 text-white' : 'bg-white/95 border-gray-300 text-gray-800'}`}
                    />
                    <input
                        type="text"
                        name="lastname"
                        placeholder="Nom"
                        value={formData.lastname}
                        onChange={handleChange}
                        required
                        className={`w-full p-2 border rounded ${isDark ? 'bg-[#0b0b0c] border-white/10 text-white' : 'bg-white/95 border-gray-300 text-gray-800'}`}
                    />
                    <input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={formData.email}
                        onChange={handleChange}
                        required
                        className={`w-full p-2 border rounded ${isDark ? 'bg-[#0b0b0c] border-white/10 text-white' : 'bg-white/95 border-gray-300 text-gray-800'}`}
                    />
                    <input
                        type="password"
                        name="password"
                        placeholder="Mot de passe (min 8 caractères)"
                        value={formData.password}
                        onChange={handleChange}
                        required
                        className={`w-full p-2 border rounded ${isDark ? 'bg-[#0b0b0c] border-white/10 text-white' : 'bg-white/95 border-gray-300 text-gray-800'}`}
                    />
                    <input
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirmez le mot de passe"
                        value={formData.confirmPassword}
                        onChange={handleChange}
                        required
                        className={`w-full p-2 border rounded ${isDark ? 'bg-[#0b0b0c] border-white/10 text-white' : 'bg-white/95 border-gray-300 text-gray-800'}`}
                    />
                    <button
                        type="submit"
                        className={`w-full p-3 rounded-lg text-white ${isDark ? 'bg-rose-600 hover:bg-rose-700' : 'bg-rose-600 hover:bg-rose-700'} transition duration-300`}
                    >
                        S'inscrire
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Register;
